export default function CaseStudy() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как обучение изменило компанию
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Реальный пример: производственная компания, 120 сотрудников. Внедрение системы обучения персонала за 6 месяцев.
        </p>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-100 shadow-sm">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-bold text-red-600 mb-4 flex items-center gap-2">
                <i className="ri-error-warning-line"></i> Ситуация
              </h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  Текучесть 32% в первый год
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  Адаптация новичков 3+ месяца
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  Жалобы клиентов на сервис
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  Зависимость от ключевых сотрудников
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-bold text-teal-600 mb-4 flex items-center gap-2">
                <i className="ri-tools-line"></i> Что сделали
              </h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  Диагностика компетенций всей команды
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  Запуск программы онбординга
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  Обучение руководителей отделов
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  Система наставничества
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  База знаний и скрипты
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-bold text-teal-600 mb-4 flex items-center gap-2">
                <i className="ri-line-chart-line"></i> Результаты
              </h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-circle-line text-teal-500 mt-0.5"></i>
                  Текучесть снизилась до 15%
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-circle-line text-teal-500 mt-0.5"></i>
                  Адаптация сократилась до 1.5 мес
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-circle-line text-teal-500 mt-0.5"></i>
                  NPS вырос с 28 до 47
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-circle-line text-teal-500 mt-0.5"></i>
                  Производительность +22%
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}